"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverlayStyles = exports.getContentStyles = void 0;
var getContentStyles = exports.getContentStyles = function getContentStyles() {
  return {
    border: 1,
    borderRadius: 4,
    boxShadow: ['0 24px 38px rgba(0, 0, 0, 0.14)', '0 9px 46px rgba(0, 0, 0, 0.12)', '0 11px 15px rgba(0, 0, 0, 0.2)'].join(),
    display: 'flex',
    flexDirection: 'column',
    padding: 30,
    transform: 'translate(-50%)',
    overflow: 'auto',
    width: '90%',
    maxWidth: '720px',
    right: '50%',
    left: '50%',
    top: '5%',
    marginBottom: 'auto',
    position: 'fixed',
    maxHeight: '855px'
  };
};
var getOverlayStyles = exports.getOverlayStyles = function getOverlayStyles() {
  return {
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    zIndex: '1000'
  };
};
//# sourceMappingURL=styles.js.map